'use client';

import { Box, Button, Heading, Image } from '@doist/marketist';
import css from './hero.module.css';
type HeroProps = {
  categories: {
    name: string;
    slug: string;
  }[];
};
export function Hero({
  categories
}: HeroProps) {
  return <>
            <Box className={css.illustrationWrapper} data-sentry-element="Box" data-sentry-source-file="hero.tsx">
                <Image src="/static/inspiration/hero-background.png" width={823} height={575} alt="" priority={true} data-sentry-element="Image" data-sentry-source-file="hero.tsx" />
                <Heading size="major-4xl" level="1" className={css.text} data-sentry-element="Heading" data-sentry-source-file="hero.tsx">
                    inspiration
                </Heading>
                <Image src="/static/inspiration/hero-foreground.png" width={823} height={575} alt="" className={css.foreground} priority={true} data-sentry-element="Image" data-sentry-source-file="hero.tsx" />
            </Box>
            <nav>
                <Box className={css.categories} tag="ul" data-sentry-element="Box" data-sentry-source-file="hero.tsx">
                    {categories.map(category => <li key={category.slug}>
                            <Button variant="quaternary" href={`/inspiration/category/${category.slug}`} className={css.category}>
                                {category.name}
                            </Button>
                        </li>)}
                </Box>
            </nav>
        </>;
}